import { create } from 'zustand';
import type { Project, ProjectListItem } from '@/types';

interface ProjectState {
  projects: ProjectListItem[];
  currentProject: Project | null;
  isLoading: boolean;
  totalCount: number;
  currentPage: number;

  setProjects: (projects: ProjectListItem[], totalCount: number, page: number) => void;
  setCurrentProject: (project: Project | null) => void;
  addProject: (project: ProjectListItem) => void;
  updateProject: (id: string, updates: Partial<ProjectListItem>) => void;
  removeProject: (id: string) => void;
  setLoading: (loading: boolean) => void;
}

export const useProjectStore = create<ProjectState>((set) => ({
  projects: [],
  currentProject: null,
  isLoading: false,
  totalCount: 0,
  currentPage: 1,

  setProjects: (projects, totalCount, page) =>
    set({ projects, totalCount, currentPage: page }),

  setCurrentProject: (project) =>
    set({ currentProject: project }),

  addProject: (project) =>
    set((state) => ({
      projects: [project, ...state.projects],
      totalCount: state.totalCount + 1,
    })),

  updateProject: (id, updates) =>
    set((state) => ({
      projects: state.projects.map((p) =>
        p.id === id ? { ...p, ...updates } : p
      ),
      currentProject:
        state.currentProject?.id === id
          ? { ...state.currentProject, ...updates }
          : state.currentProject,
    })),

  removeProject: (id) =>
    set((state) => ({
      projects: state.projects.filter((p) => p.id !== id),
      totalCount: state.totalCount - 1,
      currentProject: state.currentProject?.id === id ? null : state.currentProject,
    })),

  setLoading: (loading) =>
    set({ isLoading: loading }),
}));
